import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mummbaitomatherancab() {



    const cardData = {

keyword: "Mumbai to Matheran Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Matheran Cab services for families, couples, corporate travelers, nature lovers, and weekend holidaymakers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth and scenic journey through the Western Ghats. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, customized sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a memorable and hassle-free trip to Matheran, Maharashtra's charming eco-friendly hill station known for its lush forests, panoramic viewpoints, toy train, and pleasant climate.",

topPlaces: [
    {
        title: "Panorama Point",
        description:
            "Panorama Point is one of the most spectacular viewpoints in Matheran, offering breathtaking 360-degree views of the Sahyadri ranges, green valleys, and distant villages. It is especially famous for its magnificent sunrise and sunset views, attracting photographers and nature enthusiasts throughout the year. The peaceful surroundings and refreshing mountain air make it a must-visit destination during a Mumbai to Matheran cab trip."
    },
    {
        title: "Charlotte Lake",
        description:
            "Charlotte Lake is a beautiful freshwater lake surrounded by dense forests and scenic landscapes. The lake serves as a major water source for Matheran and becomes particularly picturesque during the monsoon season. Visitors enjoy peaceful walks, bird watching, photography, and relaxing amidst nature while exploring one of the hill station's most popular attractions."
    },
    {
        title: "Echo Point",
        description:
            "Echo Point is a favorite tourist attraction where visitors can hear their voices reverberate through the surrounding valleys. The viewpoint offers stunning views of the mountains and lush green forests, creating a memorable experience for families and groups. The pleasant atmosphere and natural beauty make it an ideal place for sightseeing and photography."
    },
    {
        title: "Louisa Point",
        description:
            "Louisa Point is known for its dramatic cliffs and panoramic views of waterfalls, valleys, and the historic Prabal Fort. During the monsoon season, the area is covered with mist and flowing streams, creating a magical landscape. Tourists enjoy the peaceful environment and breathtaking scenery while exploring this iconic Matheran viewpoint."
    },
    {
        title: "One Tree Hill Point",
        description:
            "One Tree Hill Point is named after the solitary tree standing on the hilltop and is famous for its unique landscape and scenic trekking routes. Visitors can enjoy spectacular views of the surrounding mountains and valleys while experiencing the calm and untouched beauty of Matheran. It is a popular destination for adventure lovers and photographers."
    },
    {
        title: "Porcupine Point",
        description:
            "Porcupine Point, also known as Sunset Point, is one of the best locations in Matheran to witness the setting sun over the Sahyadri Mountains. The viewpoint offers uninterrupted views of the valleys and distant hills, creating a peaceful and romantic atmosphere. Tourists often gather here to enjoy the cool breeze and capture memorable photographs."
    },
    {
        title: "Matheran Toy Train",
        description:
            "The Matheran Toy Train is a UNESCO-recognized heritage railway that offers a charming journey through forests, tunnels, and scenic mountain landscapes. The slow-paced ride allows visitors to appreciate the natural beauty of the hill station while experiencing a piece of India's railway heritage. It remains one of Matheran's most loved attractions."
    },
    {
        title: "Alexander Point",
        description:
            "Alexander Point provides magnificent views of the surrounding valleys, hills, and nearby villages, making it a favorite spot for sightseeing and nature appreciation. The location is especially beautiful during the early morning and evening hours when the landscape is covered in soft light. The tranquil environment offers a perfect escape from city life."
    },
    {
        title: "Monkey Point",
        description:
            "Monkey Point is a scenic viewpoint known for its natural beauty and the playful monkeys that inhabit the surrounding forests. Visitors enjoy panoramic views of the valleys and mountain ranges while taking leisurely walks through the lush greenery. The peaceful atmosphere and picturesque setting make it an enjoyable stop for families and wildlife enthusiasts."
    },
    {
        title: "Prabal Fort View",
        description:
            "Prabal Fort View offers stunning vistas of the historic Prabalgad Fort and the surrounding Sahyadri landscape. The viewpoint combines history, adventure, and natural beauty, making it a popular attraction for trekkers and tourists alike. Visitors can admire the rugged mountain terrain, dense forests, and scenic valleys that make Matheran one of Maharashtra's most beautiful hill stations."
    }
],



services: [
{
name: "Mumbai to Matheran Cab",
description: "Mumbai Airport Cab offers Mumbai to Matheran Cab service for safe, comfortable, and affordable travel to Maharashtra's famous hill station. Whether you are planning a family vacation, romantic getaway, weekend trip, corporate outing, school excursion, or sightseeing holiday, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles. Our experienced chauffeurs ensure a smooth journey with doorstep pickup, flexible travel schedules, one way and round trip options, transparent pricing, and 24x7 booking assistance. Enjoy a relaxing road trip to Matheran with reliable transportation and premium travel comfort."
},
{
name: "Mumbai to Matheran Taxi",
description: "Book Mumbai to Matheran Taxi with Mumbai Airport Cab for convenient and hassle-free travel. Our clean AC vehicles, professional drivers, affordable rates, and flexible pickup options provide a comfortable journey for families, couples, and groups."
},
{
name: "Mumbai to Matheran Taxi Fare",
description: "Get affordable Mumbai to Matheran Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, no hidden charges, multiple vehicle options, and economical travel packages for one way and round trip journeys."
},
{
name: "Mumbai to Matheran Cab Fare",
description: "Mumbai Airport Cab provides competitive Mumbai to Matheran Cab Fare with professional chauffeurs, comfortable vehicles, and reliable transportation services for all travellers."
},
{
name: "Cab from Mumbai to Matheran",
description: "Choose a Cab from Mumbai to Matheran with Mumbai Airport Cab and enjoy safe, comfortable, and scenic travel with experienced drivers and premium AC vehicles."
},
{
name: "Mumbai to Matheran Car Rental",
description: "Book Mumbai to Matheran Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for flexible and enjoyable travel."
},
{
name: "Mumbai to Matheran Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Matheran Cab Booking with instant confirmation, 24x7 customer support, professional drivers, and multiple vehicle choices."
},
{
name: "Mumbai to Matheran One Way Cab",
description: "Travel comfortably with Mumbai to Matheran One Way Cab service featuring fixed pricing, AC vehicles, experienced chauffeurs, and convenient pickup and drop facilities."
},
{
name: "Mumbai to Matheran Round Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Matheran Round Trip Cab packages for weekend holidays, sightseeing tours, family outings, and same-day return trips."
},
{
name: "Mumbai to Matheran Outstation Cab",
description: "Book Mumbai to Matheran Outstation Cab for comfortable long-distance travel with premium vehicles, professional drivers, and customized travel packages."
},
{
name: "Mumbai to Matheran Taxi Service",
description: "Mumbai Airport Cab offers Mumbai to Matheran Taxi Service with safe transportation, affordable fares, clean vehicles, and dependable chauffeur service."
},
{
name: "Mumbai to Matheran Car Hire",
description: "Choose Mumbai to Matheran Car Hire with Mumbai Airport Cab for premium chauffeur-driven travel featuring flexible schedules, comfortable seating, and personalized service."
},
{
name: "Mumbai to Matheran Toy Train + Cab Plan",
description: "Mumbai Airport Cab offers Mumbai to Matheran Toy Train + Cab Plan with comfortable road transport to Neral along with convenient access to the famous Matheran toy train experience for families and tourists."
},
{
name: "Mumbai to Matheran Sightseeing Cab",
description: "Book Mumbai to Matheran Sightseeing Cab for exploring popular attractions including Panorama Point, Echo Point, Charlotte Lake, Louisa Point, Alexander Point, and other scenic destinations."
},
{
name: "Mumbai Airport to Matheran Cab",
description: "Book Mumbai Airport to Matheran Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, and comfortable AC vehicles."
},
{
name: "Navi Mumbai to Matheran Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Matheran Cab service with doorstep pickup, affordable fares, premium vehicles, and reliable transportation."
},
{
name: "Thane to Matheran Cab",
description: "Choose Thane to Matheran Cab with Mumbai Airport Cab for comfortable travel, experienced chauffeurs, premium vehicles, and flexible travel schedules."
},
{
name: "Mumbai to Matheran Weekend Cab",
description: "Book Mumbai to Matheran Weekend Cab for a relaxing holiday with flexible pickup timings, premium vehicle options, and comfortable chauffeur-driven transportation."
},
{
name: "Mumbai to Matheran Family Cab",
description: "Mumbai Airport Cab provides Mumbai to Matheran Family Cab service with spacious vehicles, safe drivers, and customized travel plans designed for enjoyable family vacations."
}
],

tableData: [
["Mumbai to Matheran Cab","Mumbai to Matheran Taxi"],
["Mumbai to Matheran Taxi Fare","Mumbai to Matheran Cab Fare"],
["Cab from Mumbai to Matheran","Mumbai to Matheran Car Rental"],
["Mumbai to Matheran Cab Booking","Mumbai to Matheran One Way Cab"],
["Mumbai to Matheran Round Trip Cab","Mumbai to Matheran Outstation Cab"],
["Mumbai to Matheran Taxi Service","Mumbai to Matheran Car Hire"],
["Mumbai to Matheran Toy Train + Cab Plan","Mumbai to Matheran Sightseeing Cab"],
["Mumbai Airport to Matheran Cab","Navi Mumbai to Matheran Cab"],
["Thane to Matheran Cab","Mumbai to Matheran Weekend Cab"],
["Mumbai to Matheran Family Cab","Mumbai to Matheran Holiday Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Matheran Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai to Matheran Cab transportation for families, couples, tourists, corporate travelers, and nature lovers seeking a comfortable journey."
},
{
WhyChooseheading: "Perfect Hill Station Getaway",
WhyChoosedescription: "Matheran is one of Maharashtra’s most popular eco-friendly hill stations, and our cab service offers convenient travel for relaxing vacations and weekend trips."
},
{
WhyChooseheading: "Comfortable and Scenic Travel Experience",
WhyChoosedescription: "Enjoy a pleasant drive through beautiful hills, greenery, and scenic routes while traveling from Mumbai to Matheran in our well-maintained vehicles."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel preferences."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you need a one-way drop, same-day return, round trip, or customized sightseeing package, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our experienced drivers and regularly serviced vehicles ensure a safe, comfortable, and stress-free journey throughout the trip."
},
{
WhyChooseheading: "Ideal for Families, Couples, and Groups",
WhyChoosedescription: "From romantic getaways to family vacations and group outings, we offer suitable vehicle options for every type of traveler."
}
]
};

const faqData = [
{
question: "Why do travelers book Mumbai to Matheran Cabs?",
answer: "Matheran is a famous hill station known for its pleasant weather, scenic viewpoints, toy train, lush greenery, and peaceful atmosphere."
},
{
question: "Can I book a one-way cab from Mumbai to Matheran?",
answer: "Yes, one-way cab services are available along with round-trip and customized sightseeing travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Matheran travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most preferred options for comfortable hill station travel."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their sightseeing plans and travel schedule."
},
{
question: "Can families use this service for vacations?",
answer: "Yes, families frequently book Mumbai to Matheran Cabs for holidays, picnics, and weekend getaways."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and sightseeing tours."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Can sightseeing locations be included during the trip?",
answer: "Yes, customers can visit Panorama Point, Echo Point, Charlotte Lake, Louisa Point, Alexander Point, and other popular attractions."
},
{
question: "Is advance reservation recommended for Mumbai to Matheran travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning, especially during weekends and holiday seasons."
},
{
question: "How can I book a Mumbai to Matheran Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Aniket Patil",
feedback:
"We booked a Mumbai to Matheran Cab for a family vacation. The vehicle was clean, the driver was courteous, and the journey was extremely comfortable.",
rating: 5
},
{
id: 2,
name: "Mrs. Rutuja Shah",
feedback:
"Our Matheran weekend trip was wonderful with Mumbai Airport Cab Service. The pickup was punctual, the cab was spacious, and the overall travel experience was excellent.",
rating: 5
}
];
































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Matheran Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-matheran-cab.jpg",
"description": "Book Mumbai to Matheran cab service for a short and scenic hill station trip. Mumbai Airport Cabs offers reliable taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options for Matheran travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-matheran-cab"
}
};








    return (
        <div>


<Helmet>
  <title>Mumbai to Matheran Cab | Taxi Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Matheran cab service at affordable fares. Safe and comfortable taxi service with professional drivers, one-way and round-trip options, and hassle-free hill station travel."
/>

<meta
 name="keywords"
 content="mumbai to matheran cab, mumbai to matheran taxi, mumbai to matheran taxi fare, mumbai to matheran cab fare, cab from mumbai to matheran, mumbai to matheran car rental, mumbai to matheran cab booking, mumbai to matheran one way cab, mumbai to matheran round trip cab, mumbai to matheran outstation cab, matheran cab from mumbai, hill station cab mumbai to matheran, outstation taxi mumbai to matheran, mumbai to matheran taxi service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mummbaitomatherancab;